// extracted by mini-css-extract-plugin
module.exports = {"main":"AddQuizForm_main__2Jg0r","add_quiz_container":"AddQuizForm_add_quiz_container__yX1fi","btn_div":"AddQuizForm_btn_div__-ndKe","btn_label":"AddQuizForm_btn_label__2XNap"};